
import { defineComponent } from 'vue';

export default defineComponent({
    setup() {
        let isUcloud = window.location.href.indexOf('ucloud.akuvox.com') > -1;
        if (process.env.NODE_ENV === 'development' || window.location.href.indexOf('test84.akuvox') > -1) {
            isUcloud = true;
        }
        return {
            isUcloud
        };
    }
});

